import { OrderbookTabs } from './orderbook.tabs'

interface OrderbookProps {
  className?: string
  hideTabs?: boolean
  borderLess?: boolean
  paddingLess?: boolean
}

export function Orderbook(props: OrderbookProps) {
  const { className, hideTabs, borderLess, paddingLess } = props
  return (
    <OrderbookTabs
      className={className}
      hideTabs={hideTabs}
      borderLess={borderLess}
      paddingLess={paddingLess}
    />
  )
}
